<div fxFlex="100" class="inputs" fxLayout="row wrap">
  <!-- Department Name -->
  <app-edit-suggestion-field [isEditable]="true" [label]="'Department Name*'" [name]="'department_name'"
    [(ngModel)]="departmentObject.name" (onSelect)="editDepartmentMaster($event)"
    [disabled]="departmentObject?.readonly" [listUrl]="department_url+'department/?name=::search::'" displayField="name"
    class="m1em" fxFlex="12em" fxFlex.xs="10em" fxLayout="column" [errors]="errorObj.name">
  </app-edit-suggestion-field>

  <!-- Parent Department -->
  <app-mat-auto-search [isEditable]="true" [label]="'Parent Department, if any'" [(ngModel)]="departmentObject.parent"
    [name]="'parent'" [displayField]="'name'" [listUrl]="department_url+'department/?name=::search::'"
    [disabled]="departmentObject?.readonly" class="ai-fxs m1em " fxFlex="12em" fxFlex.xs="10em" fxLayout="column"
    [errors]="errorObj.parent">
  </app-mat-auto-search>

  <!-- Description -->
  <app-text-field [isMultiline]="true" [isEditable]="true" [label]="'Description'"
    [(ngModel)]="departmentObject.description" [name]="'description'" [disabled]="departmentObject?.readonly"
    class="m1em countriesInput" fxFlex="26.4em" fxFlex.xs="100" fxLayout="column" [errors]="errorObj.description">
  </app-text-field>

  <div class="ai-fxs m1em" fxFlex="26.4em" fxFlex.xs="100" fxLayout="column">
    <section>
      <mat-checkbox color="primary" [(ngModel)]="departmentObject.is_active" checked
        [disabled]="departmentObject?.readonly">Active</mat-checkbox>
    </section>
  </div>
  <div class="ai-fxs m1em" fxFlex="26.4em" fxFlex.xs="100" fxLayout="column">
    <div class="container">
      <span [class.lock]="true" [class.unlocked]="!departmentObject?.readonly" (click)="lock(departmentObject)"></span>
      <span id="lockText"> {{departmentObject?.readonly ? 'Closed': 'Opened'}} For Editing</span>
    </div>
  </div>
  <div class="btnb">
    <button mat-stroked-button class="nxt" (click)="onDepartmentSave()">Save</button>
  </div>
</div>